export default "__VITE_ASSET__A45UIGSN__"